module.exports = __webpack_public_path__ + "img/product_3.db6e1925.jpg";